module.exports = __webpack_public_path__ + "img/case2.6337467d.png";